function ReserveButton({id="", subject, action, disabled = false, text, disabledText}) {
  return (
    <button
      id={id}
      className="button is-primary mt-auto"
      disabled={disabled}
      style={{ "disabled": disabled }}
      onClick={() => {
        if (disabled) return;
        action(subject);
      }
      }>{disabled ? disabledText : text }</button>
  );
}

export default ReserveButton;